/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";
import * as communicationActions from "../../redux/actions/communicationActions";
import Form from "./WorkflowForm";
import Editor from "./Editor";

const mapDispatchToProps = {
  ...communicationActions,
};

const validate = (values) => {
  const errors = {};

  if (!values.to || !values.to.length) {
    errors.to = "Required!";
  }

  return errors;
};

const mapStateToProps = (state) => {
  const {
    workflows,
    communications: { admins, coaches },
  } = state;

  return {
    stateWorkflow: workflows,
    admins,
    coaches,
  };
};

function EditTabTriggerEmail({
  placeholder,
  patchWorkflowStep,
  smartFields,
  admins,
  fetchAdmins,
  fetchCoaches,
  canSaveWorkflow,
  coaches,
  event,
  stateWorkflow,
}) {
  React.useEffect(() => {
    fetchAdmins();
    fetchCoaches();
  }, [fetchAdmins, fetchCoaches]);

  const [formErrors, setFormErrors] = React.useState({});

  const eventWorkFlow = stateWorkflow[event];

  const workflow = eventWorkFlow.blocks.find(
    (b) => b.id === stateWorkflow.activeWorkflowId,
  );

  const runValidation = React.useCallback(() => {
    const errors = validate(workflow);

    setFormErrors(errors);
  }, [workflow]);

  const suggestedPersons = [
    ...admins,
    ...coaches,
    ...[
      { id: "ADMINS", name: "ADMINS" },
      { id: "ALLSTAFF", name: "ALL STAFF" },
      { id: "COACHES", name: "COACHES" },
      { id: "MEMBER", name: "MEMBER" },
    ],
  ];

  const handlePatchWorkflowStep = React.useCallback(
    (id, patch) => {
      patchWorkflowStep(event, id, patch);
    },
    [patchWorkflowStep, event],
  );

  let selectOptions = suggestedPersons.map((person) => ({
    label: person.name,
    value: person.id,
  }));

  const selectValues = workflow.to.map((person) => ({
    label: person.name,
    value: person.id,
  }));

  selectOptions = selectOptions.filter((option) => {
    const alreadySelected = selectValues.find((v) => v.label === option.label);

    if (alreadySelected) return false;

    return true;
  });

  const handleSelectOptions = React.useCallback(
    (change) => {
      const changes = change.map((c) => c.value);

      const patch = changes.map((c) => {
        const person = suggestedPersons.find((p) => p.id === c);

        return { ...person };
      });

      handlePatchWorkflowStep(workflow.id, { to: patch });

      runValidation();

      canSaveWorkflow(event, workflow.id);
    },
    [
      suggestedPersons,
      handlePatchWorkflowStep,
      canSaveWorkflow,
      event,
      runValidation,
      workflow.id,
    ],
  );

  if (!workflow) return null;

  return (
    <div>
      <div className="pp_trigger_edit_panel_block">
        <span className="pp_trigger_edit_panel_block_title">To</span>
        <span className="pp_trigger_edit_panel_block_title">
          <Select
            defaultValue={selectValues}
            onChange={handleSelectOptions}
            isMulti
            name="persons"
            options={selectOptions}
            className={`basic-multi-select ${
              (formErrors.to || stateWorkflow.errors.to) && !selectValues.length
                ? "pp_trigger_edit_panel_block_input_error"
                : ""
            }`}
            classNamePrefix="select"
          />
        </span>
        {(stateWorkflow.errors.to || formErrors.to) && !selectValues.length && (
          <p className="pp_trigger_error">
            {formErrors.to || stateWorkflow.errors.to}
          </p>
        )}
      </div>
      <Form
        activeWorkflowId={stateWorkflow.activeWorkflowId}
        event={event}
        handlePatchWorkflowStep={handlePatchWorkflowStep}
        smartFieldOptions={smartFields}
        replyToEmail={workflow.replyToEmail}
        replyToName={workflow.replyToName}
        delayedPatch={handlePatchWorkflowStep}
      />
      <Editor
        event={event}
        placeholder={placeholder}
        smartFieldOptions={smartFields}
        handlePatchWorkflowStep={handlePatchWorkflowStep}
      />
    </div>
  );
}

/*
 * PropType validation
 */
EditTabTriggerEmail.propTypes = {
  admins: PropTypes.array.isRequired,
  event: PropTypes.string.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
  coaches: PropTypes.array.isRequired,
  fetchAdmins: PropTypes.func.isRequired,
  fetchCoaches: PropTypes.func.isRequired,
  canSaveWorkflow: PropTypes.func.isRequired,
  patchWorkflowStep: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  smartFields: PropTypes.array.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditTabTriggerEmail);
